<template>
  <div class="home">
    <div class="monitor">
      <div class="real-time" @click="toggle">
        时间维度
        <div class="span">
          <img :src="hide ? arrowTop: arrowBottom" />
        </div>
      </div>
      <div class="data-analysis" v-show="hide" @click="analysis">实时监测</div>
      <div class="time">
        <ul>
            <li :class="{'active': nav == '1'}" @click="timeClick('/day');nav ='1'">日</li>
            <li :class="{'active': nav == '2'}" @click="timeClick('/week'); nav ='2'">周</li>
            <li :class="{'active': nav == '3'}" @click="timeClick('/month'); nav ='3'">月</li>
            <li :class="{'active': nav == '4'}" @click="timeClick('/custom'); nav ='4'" class="none">自定义</li>
        </ul>
      </div>
    </div>
    <article class="angel-other">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </article>
  </div>
</template>

<script>
const arrowTop = require('@/assets/img/home/arrow-top.png')
const arrowBottom = require('@/assets/img/home/arrow-bottom.png')
export default {
  data() {
    return {
      hide:false,
      arrowTop,
      arrowBottom
    }
  },
  components: {
  },
  computed: {
     nav: { // 页签激活重构 ，active-tab  from store nav => compute => :class 表达式 ，路由跳转和页签激活关注点分离
      get () {
        // 用户直接访问 以下四个地址时，修正；可以不考虑这种特殊场景
        const path = this.$route.path
        if (path === '/day') {
          return '1'
        }
        if (path.startsWith('/week')) {
          return '2'
        } else if (path.startsWith('/month')) {
          return '3'
        } else if (path.startsWith('/custom')) {
          return '4'
        }
        // 默认激活首页
        return '4'
      },
      set () {
      }
    }
  },
  methods: {
    toggle () {
      this.hide = !this.hide
    },
    analysis () {
       this.$router.push({
        path: 'home'
      })

      this.hide = false
    },
    timeClick (obj) {
      this.$router.push({
        path: obj,
        query: { sn: this.$route.query.sn }
      })
    }
  },
};
</script>

<style lang="less" scoped>
  .home{
    font-size:14px;
    .bd1{
        border-bottom:1px solid #F5F7FF;
    }
    .monitor{
      padding:0 10px;
      height:60px;
      line-height: 60px;
      background: #fff;
      vertical-align: middle;
      margin-bottom:5px;
      .real-time {
      margin-left: 10px;
      color: #333;
      font-size: 16px;
      display: inline-block;
      vertical-align: middle;
      .span {
        width: 14px;
        height: 14px;
        background: #8992a9;
        border-radius: 2px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 6px;
        text-align: center;
        line-height: 6px;
        img {
          width: 8px;
          height: 4px;
        }
      }
    }
    .data-analysis {
      position: absolute;
      width: 76px;
      height: 33px;
      line-height: 33px;
      background: #0e1526;
      text-align: center;
      opacity: 0.8;
      left: 25px;
      top: 40px;
      font-size: 12px;
      color:#fff;
    }
      .text{
        margin-left:10px;
        color:#333;
        font-size: 16px;
        vertical-align: middle;
        display: inline-block;
      }
      .time{
        float: right;
        color:#656565;
        font-size:12px;
        ul:after{/*伪元素是行内元素 正常浏览器清除浮动方法*/
            content: "";
            display: block;
            height: 0;
            clear:both;
            visibility: hidden;
        }
        ul {
            border:1px solid #458BFF;
            margin-top:15px;
            border-radius: 3px;
            text-align: center;
            li{
                float: left;
                width:50px;
                height:30px;
                line-height: 30px;
                border-right:1px solid #458BFF;
            }
            .none{
                border-right:none;
            }
            .active{
                background: #458BFF;
                color:#fff;
            }
        }
      }
    }
  }
</style>
